/**
 * Get asset link from file path
 * @param {string} srcMode - Source mode: "cdn" or "link"
 * @param {object|string} fileData - File data object with filePath or direct URL string
 * @returns {string} Asset URL
 */
export const getAssetLink = (srcMode, fileData) => {
  if (srcMode === "cdn") {
    if (typeof fileData === "string") {
      // If fileData is already a URL string, return it
      return fileData;
    }
    // If fileData is an object with filePath
    if (fileData?.filePath) {
      // Check if it's already a full URL
      if (fileData.filePath.startsWith("http://") || fileData.filePath.startsWith("https://")) {
        return fileData.filePath;
      }
      // Construct CDN URL
      return `https://cdn.grigora.co/${fileData.filePath}`;
    }
    // Fallback: if fileData has other properties, try to construct URL
    if (fileData?.name && fileData?.extension) {
      return `https://cdn.grigora.co/${fileData.name}.${fileData.extension}`;
    }
  } else if (srcMode === "link") {
    // Return as-is if it's a link
    return typeof fileData === "string" ? fileData : fileData?.filePath || "";
  }
  
  // Default fallback
  return typeof fileData === "string" ? fileData : fileData?.filePath || "";
};

